import {
  SYSTEM_BENEFITS_MODAL_CHANGE,
} from './constants';

export function benefitsModalChange(visible,type) {
  return {
    type: SYSTEM_BENEFITS_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_BENEFITS_MODAL_CHANGE:
      return {
        ...state,
        benefitsModalType:action.data.type,
        benefitsModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/benefitsModalChange.js